import DataDisplayRowI from "../DataDisplayRowI";
import getWebOrderRow from "../DataDisplayRow/WebOrderRow";
import DataDisplayTable from "../DataDisplayTable";

class WebOrderTable extends DataDisplayTable {
    #row!: DataDisplayRowI;

    generateRow(): DataDisplayRowI {
        return this.#row = getWebOrderRow()
    }
}

let webOrderTable: WebOrderTable | null = null;

export default function getWebOrderTable(): WebOrderTable {
    if (webOrderTable === null)
        webOrderTable = new WebOrderTable()
    return webOrderTable
}